export enum QueryKey {
  getGroup = 'getGroup',
  getWhitelist = 'getWhitelist',
  generateWhitelistLink = 'generateWhitelistLink',
  removeWhitelistUser = 'removeWhitelistUser',
}
